import { getRootDeputyFrame } from '@/global-libs/deputy-embed';

function getDDLogger() {
  const deputyWindow = getRootDeputyFrame();
  if (deputyWindow.DD_LOGS) {
    return deputyWindow.DD_LOGS.logger;
  }
  console.error('Datadog logger not found');
}

export function ddLogInfo(message, params) {
  const logger = getDDLogger();
  if (logger) {
    logger.info(message, params);
  }
}

export function ddLogError(message, params, error) {
  const logger = getDDLogger();
  if (logger) {
    logger.error(message, params, error);
  }
}
